<template>
    <div class="menu-container">
        <div @click="openSettings" class="menu-item settings">
            <i class="fas fa-gear popup-menu-icon"></i>
            <span class="menu-title">تنظیمات</span>
        </div>
        <div class="menu-item about">
            <a href="https://noticapp.ir" target="_blank">
                <i class="fas fa-info-circle popup-menu-icon"></i>
                <span class="menu-title">درباره نوتیکا</span>
            </a>
        </div>
        <div class="menu-item support">
            <i class="fas fa-headset popup-menu-icon"></i>
            <span class="menu-title">تماس با پشتیبانی</span>
        </div>
        <div @click="logout" class="menu-item logout">
            <i class="fas fa-sign-out-alt popup-menu-icon"></i>
            <span class="menu-title">خروج از حساب کاربری</span>
        </div>
    </div>
</template>

<script>
export default {
    methods: {
        openSettings() {
            this.$emit('openSettings');
        },
        logout() {
            this.$emit('logout');
        }
    }

}
</script>

<style scoped>
.menu-container {
    display: none;
    flex-direction: column;
    position: absolute;
    top: 60px;
    right: 10px;
    background-color: rgba(0, 0, 0, 0.9);
    border-radius: 10px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.25);
    padding: 10px;
    z-index: 10;
    align-items: flex-start;
}

.popup-menu-icon {
    font-size: 20px;
    color: white;
    cursor: pointer;
    margin: auto 10px;
}

.menu-title {
    /* margin-left: 10px; */
    margin: auto 10px;
    color: white;
    cursor: pointer;
    transition: all 0.3s;
}

.menu-item {
    padding: 10px;
    color: white;
    cursor: pointer;
    transition: all 0.3s;
}

a {
    text-decoration: none;
}

</style>